import { Apollo } from 'src/gql/generated';

export function getHasAiReasoning<
  T extends { mode?: Apollo.ExtractionQuestionMode | null; reasoning?: string | null },
>(job: T): job is T & { reasoning: string } {
  return (
    typeof job.reasoning === 'string' &&
    job.reasoning.length > 0 &&
    job.mode === Apollo.ExtractionQuestionMode.Ai
  );
}
